import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { ref, watch } from 'vue';
import { useTrucodeReferenceStore } from 'stores/references-store';

export interface Props {
    articleId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesContent',
  props: {
    articleId: { default: '' }
  },
  setup(__props: any) {

const content = ref<HTMLElement | undefined>(undefined);

const props = __props;

watch(
  () => props.articleId,
  async (newArticleId) => {
    if (newArticleId) {
      content.value = undefined;
      await useTrucodeReferenceStore().getReferencesArticle(newArticleId).then((newContent) => {
        content.value = newContent;
      });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "reference-content",
    innerHTML: content.value
  }, null, 8, _hoisted_1))
}
}

})